export default [
  {
    name: 'VERSAO',
    value: 'Versão'
  },
  {
    name: 'ACAO',
    value: 'Ação'
  },
  {
    name: 'CNS',
    value: 'CNS'
  },
  {
    name: 'INDICEREGISTRO',
    value: 'Índice do registro'
  },
  {
    name: 'NOMECONJUGE1',
    value: 'nome do cônjuge 1'
  },
  {
    name: 'NOVONOMECONJUGE1',
    value: 'Novo nome do cônjuge 1'
  },
  {
    name: 'CPFCONJUGE1',
    value: 'CPF do cônjuge 1'
  },
  {
    name: 'SEXOCONJUGE1',
    value: 'Sexo do cônjuge 1'
  },
  {
    name: 'DATANASCIMENTOCONJUGE1',
    value: 'Data de nascimento do cônjuge 1'
  },
  {
    name: 'NOMEPAICONJUGE1',
    value: 'nome do pai do cônjuge 1'
  },
  {
    name: 'SEXOPAICONJUGE1',
    value: 'Sexo do pai do cônjuge 1'
  },
  {
    name: 'NOMEMAECONJUGE1',
    value: 'nome da mãe do cônjuge 1'
  },
  {
    name: 'SEXOMAECONJUGE1',
    value: 'Sexo da mãe do cônjuge 1'
  },
  {
    name: 'CODIGOOCUPACAOSDCCONJUGE1',
    value: 'Código da ocupação declarada do cônjuge 1'
  },
  {
    name: 'PAISNASCIMENTOCONJUGE1',
    value: 'Pais de nascimento do cônjuge 1'
  },
  {
    name: 'NACIONALIDADECONJUGE1',
    value: 'Nacionalidade do cônjuge 1'
  },
  {
    name: 'CODIGOIBGEMUNNATCONJUGE1',
    value: 'Código IBGE do município de naturalidade do cônjuge 1'
  },
  {
    name: 'TEXTOLIVREMUNNATCONJUGE1',
    value: 'Texto livre do município de naturalidade do cônjuge 1'
  },
  {
    name: 'CODIGOIBGEMUNLOGRADOURO1',
    value: 'Código IBGE do município do logradouro do cônjuge 1'
  },
  {
    name: 'DOMICILIOESTRANGEIRO1',
    value: 'Domicílio estrangeiro do cônjuge 1'
  },
  {
    name: 'NOMECONJUGE2',
    value: 'nome do cônjuge 2'
  },
  {
    name: 'NOVONOMECONJUGE2',
    value: 'novo nome do cônjuge 2'
  },
  {
    name: 'CPFCONJUGE2',
    value: 'CPF do cônjuge 2'
  },
  {
    name: 'SEXOCONJUGE2',
    value: 'Sexo do cônjuge 2'
  },
  {
    name: 'DATANASCIMENTOCONJUGE2',
    value: 'Data de nascimento do cônjuge'
  },
  {
    name: 'NOMEPAICONJUGE2',
    value: 'nome do pai do cônjuge 2'
  },
  {
    name: 'SEXOPAICONJUGE2',
    value: 'Sexo do pai do cônjuge 2'
  },
  {
    name: 'NOMEMAECONJUGE2',
    value: 'nome da mãe do cônjuge 2'
  },
  {
    name: 'SEXOMAECONJUGE2',
    value: 'Sexo da mãe do cônjuge 2'
  },
  {
    name: 'CODIGOOCUPACAOSDCCONJUGE2',
    value: 'Código ocupação do cônjuge 2'
  },
  {
    name: 'PAISNASCIMENTOCONJUGE2',
    value: 'Pais de nascimento do cônjuge 2'
  },
  {
    name: 'NACIONALIDADECONJUGE2',
    value: 'Nacionalidade do cônjuge 2'
  },
  {
    name: 'CODIGOIBGEMUNNATCONJUGE2',
    value: 'Código IBGE do município de naturalidade do cônjuge 2'
  },
  {
    name: 'CODIGOIBGEMUNLOGRADOURO2',
    value: 'Código IBGE do município do logradouro do cônjuge 2'
  },
  {
    name: 'DOMICILIOESTRANGEIRO2',
    value: 'Domicílio estrangeiro do cônjuge 2'
  },
  {
    name: 'MATRICULA',
    value: 'Matrícula'
  },
  {
    name: 'DATAREGISTRO',
    value: 'Data do registro'
  },
  {
    name: 'DATACASAMENTO',
    value: 'Data do casamento'
  },
  {
    name: 'REGIMECASAMENTO',
    value: 'Regime do casamento'
  },
  {
    name: 'DOCUMENTOS',
    value: 'Documentos'
  },
  {
    name: 'INDICEREGISTRO',
    value: 'Índice do registro'
  },
  {
    name: 'DONO',
    value: 'Dono'
  },
  {
    name: 'TIPO_DOC',
    value: 'Tipo de documento'
  },
  {
    name: 'DESCRICAO',
    value: 'Descrição'
  },
  {
    name: 'NUMERO',
    value: 'Número'
  },
  {
    name: 'NUMERO_SERIE',
    value: 'Número de série'
  },
  {
    name: 'CODIGOORGAOEMISSOR',
    value: 'Código do orgão emissor'
  },
  {
    name: 'UF_EMISSAO',
    value: 'UF emissor'
  },
  {
    name: 'DATA_EMISSAO',
    value: 'Data de emissão'
  },
  {
    name: 'ORGAOEMISSOREXTERIOR',
    value: 'Orgão emissor exterior'
  },
  {
    name: 'INFORMACOESCONSULADO',
    value: 'Informação de consulado'
  },
  {
    name: 'OBSERVACOES',
    value: 'Observações'
  },
  {
    name: 'data_proclamas',
    value: 'Data Proclamas'
  },
  {
    name: 'cpf_conjuge_1',
    value: 'CPF do cônjuge 1'
  },
  {
    name: 'nome_conjuge_1',
    value: 'nome do cônjuge 1'
  },
  {
    name: 'novo_nome_conjuge_1',
    value: 'Novo nome do cônjuge 1'
  },
  {
    name: 'sexo_conjuge_1',
    value: 'Sexo do cônjuge 1'
  },
  {
    name: 'data_nascimento_conjuge_1',
    value: 'Data de nascimento do cônjuge 1'
  },
  {
    name: 'cep_logradouro_conjuge_1',
    value: 'CEP logradouro do cônjuge 1'
  },
  {
    name: 'logradouro_conjuge_1',
    value: 'Logradouro do cônjuge 1'
  },
  {
    name: 'num_logradouro_conjuge_1',
    value: 'Número do logradouro do cônjuge !'
  },
  {
    name: 'complemento_conjuge_1',
    value: 'Complemento do cônjuge 1'
  },
  {
    name: 'bairro_conjuge_1',
    value: 'Bairro do cônjuge 1'
  },
  {
    name: 'codigo_ibge_mun_logradouro_1',
    value: 'Código IBGE do município do logradouro 1'
  },
  {
    name: 'domicilio_estrangeiro_1',
    value: 'Domicílio estrangeiro 1'
  },
  {
    name: 'codigo_ibge_mun_nat_conjuge_1',
    value: 'Código IBGE município de naturalidade do cônjuge 1'
  },
  {
    name: 'texto_livre_mun_nat_conjuge_1',
    value: 'Texto livre do município de naturalidade do cônjuge 1'
  },
  {
    name: 'nacionalidade_conjuge_1',
    value: 'Nacionalidade do cônjuge 1'
  },
  {
    name: 'pais_nascimento_conjuge_1',
    value: 'País de nascimento de cônjuge 1'
  },
  {
    name: 'texto_livre_ocupacao_conjuge_1',
    value: 'Texto livre ocupação do cônjuge 1'
  },
  {
    name: 'estado_civil_conjuge_1',
    value: 'Estado civil do cônjuge 1'
  },
  {
    name: 'filiacao_genitor_1_conjuge_1',
    value: 'Filiação do genitor 1 do cônjuge 1'
  },
  {
    name: 'sexo_genitor_1_conjuge_1',
    value: 'Sexo genitor 1 do cônjuge 1'
  },
  {
    name: 'filiacao_genitor_2_conjuge_1',
    value: 'Filiação do genitor 2 do cônjuge 1'
  },
  {
    name: 'sexo_genitor_2_conjuge_1',
    value: 'Sexo do genitor 2 do cônjuge 1'
  },
  {
    name: 'cpf_conjuge_2',
    value: 'CPF do cônjuge 2'
  },
  {
    name: 'nome_conjuge_2',
    value: 'nome do cônjuge 2'
  },
  {
    name: 'novo_nome_conjuge_2',
    value: 'Novo nome do cônjuge 2'
  },
  {
    name: 'sexo_conjuge_2',
    value: 'Sexo de cônjuge 2'
  },
  {
    name: 'data_nascimento_conjuge_2',
    value: 'Data de nascimento do cônjuge 2'
  },
  {
    name: 'cep_logradouro_conjuge_2',
    value: 'CEP logradouro cônjuge 2'
  },
  {
    name: 'logradouro_conjuge_2',
    value: 'Logradouro cônjuge 2'
  },
  {
    name: 'num_logradouro_conjuge_2',
    value: 'Número do logradouro do cônjuge 2'
  },
  {
    name: 'complemento_conjuge_2',
    value: 'Complemento do cônjuge 2'
  },
  {
    name: 'bairro_conjuge_2',
    value: 'Bairro do cônjuge 2'
  },
  {
    name: 'codigo_ibge_mun_logradouro_2',
    value: 'Código IBGE do município do logradouro 2'
  },
  {
    name: 'domicilio_estrangeiro_2',
    value: 'Domicílio estrangeiro 2'
  },
  {
    name: 'codigo_ibge_mun_nat_conjuge_2',
    value: 'Código IBGE do município de naturalidade do cônjuge 2'
  },
  {
    name: 'texto_livre_mun_nat_conjuge_2',
    value: 'Texto livre do município de naturalidade do cônjuge 2'
  },
  {
    name: 'nacionalidade_conjuge_2',
    value: 'Nacionalidade do cônjuge 2'
  },
  {
    name: 'pais_nascimento_conjuge_2',
    value: 'País de nascimento de cônjuge 2'
  },
  {
    name: 'texto_livre_ocupacao_conjuge_2',
    value: 'Texto livre da ocupação do cônjuge 2'
  },
  {
    name: 'estado_civil_conjuge_2',
    value: 'Estado civil do cônjuge 2'
  },
  {
    name: 'filiacao_genitor_1_conjuge_2',
    value: 'Filiação do genitor 1 do cônjuge 2'
  },
  {
    name: 'sexo_genitor_1_conjuge_2',
    value: 'Sexo do Genitor 1 do cônjuge 2'
  },
  {
    name: 'filiacao_genitor_2_conjuge_2',
    value: 'Filiação do genitor 2 do cônjuge 2'
  },
  {
    name: 'sexo_genitor_2_conjuge_2',
    value: 'Sexo genitor 2 do cônjuge 2'
  },
  {
    name: 'matricula',
    value: 'Matrícula'
  },
]
